import brandSupportedLocales from './constants/brandSupportedLocales';

const TldNavLinkBuilderComponent = {
  name: '_TldNavLink_',
  requiresParent: {
    message: 'TldNavLink must only be used in a ListColumn',
    query: {
      'component.name': {
        $in: ['_ListColumn_'],
      },
    },
  },
  inputs: [
    {
      name: 'tldToNavigateTo',
      friendlyName: 'TLD to navigate to',
      helperText:
        'The country TLD that this link should navigate to. For example, select "US" to navigate to the .com site. Copy is provided via an RB key out of the "global.cta" group.',
      type: 'string',
      defaultValue: brandSupportedLocales[0],
      enum: [...brandSupportedLocales],
      localized: false,
    },
    {
      name: 'dataAnalytics',
      friendlyName: 'Data Analytics',
      type: 'object',
      subFields: [
        {
          name: 'label',
          friendlyName: 'Analytics Label',
          helperText:
            'Label provided through to analytics services. Example: T2_Men_Bottoms',
          type: 'string',
          required: true,
          localized: false,
        },
        {
          name: 'category',
          friendlyName: 'Analytics Category',
          helperText:
            'Category provided through to analytics services. Example: navigation',
          type: 'string',
          required: true,
          localized: false,
        },
      ],
    },
  ],
} as const;

export default { TldNavLinkBuilderComponent };
